export const GlobalAIAssistantViewKey="aiAssistant";export const GlobalEstatePlanningViewKey="EstatePlanning";